export const AVAILABILITY_TOGGLE = 'AVAILABILITY_TOGGLE';
export const DESKTOP_OPEN_BROWSER = 'DESKTOP_OPEN_BROWSER'; // DO NOT CHANGE: Also defined in Desktop
export const GLOBAL_SEARCH_FORM_FOCUSED = 'GLOBAL_SEARCH_FORM_FOCUSED';
export const GLOBAL_SEARCH_FORM = 'search';
